import { render, staticRenderFns } from "./LoginSelection.vue?vue&type=template&id=2c4a86e8&scoped=true"
import script from "./LoginSelection.vue?vue&type=script&lang=js"
export * from "./LoginSelection.vue?vue&type=script&lang=js"
import style0 from "./LoginSelection.vue?vue&type=style&index=0&id=2c4a86e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4a86e8",
  null
  
)

export default component.exports